angular.module('bb.users').controller('GroupListCtrl', GroupListCtrl);

GroupListCtrl.$inject = ['$scope', '$resource'];

function GroupListCtrl($scope: todo, $resource: todo) {
  const Group = $resource('/group/:groupId');

  const init = () => {
    Group.query().$promise.then((data: todo) => {
      $scope.groups = data;
      $scope.dataLoaded = true;
    });
  };

  init();

  $scope.delete = (groupId: todo) => {
    swal(
      {
        title: 'Delete Group',
        text: 'Are you sure you want to delete this group?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        closeOnConfirm: true,
      },
      () => {
        $scope.dataLoaded = false;
        Group.delete({ groupId }).$promise.then(() => {
          init();
        });
      },
    );
  };
}

export {};
